@if (showTitle) {
<div class="teams">
  <h4>{{ 'NGX-MESSAGING.TAGS.teams' | translate }}</h4>
</div>
} @if (!isLoadingTags()) {
<div class="tags" [ngStyle]="{ 'max-height': maxTagsListHeigt }">
  @for (tag of tags(); track tag.displayName) {
  <div class="tags__button" [ngClass]="{ 'tags__button-selected': checkTagsSelected(tag) }" (click)="selectTags(tag)">
    {{ tag.displayName }}
  </div>
  }
</div>
} @else {
{{ 'NGX-MESSAGING.TAGS.loadingTeams' | translate }}
}
